/**
 * Public Firebase + Billing API config only. Never place Stripe secrets here.
 */

function trimSlash(url) {
  const value = String(url || "").trim();
  if (!value) return "";
  return value.endsWith("/") ? value.slice(0, -1) : value;
}

export const billingWebConfig = {
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
  },
  appCheckSiteKey: process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY || "",
  billingApiBaseUrl: trimSlash(process.env.REACT_APP_BILLING_API_BASE_URL || ""),
  publicWebCheckoutEnabled: process.env.REACT_APP_PUBLIC_WEB_CHECKOUT_ENABLED === "true",
  sandboxLane: process.env.REACT_APP_BILLING_SANDBOX === "true",
  returnOrigin: "https://www.stratifybacktesting.com",
  supportEmail: "stratify.help@gmail.com",
  supportUrl: "/support",
  appleSubscriptionsUrl: "https://apps.apple.com/account/subscriptions",
};

export function isFirebaseConfigured() {
  const firebase = billingWebConfig.firebase;
  return Boolean(firebase.apiKey && firebase.authDomain && firebase.projectId && firebase.appId);
}

export function isBillingApiConfigured() {
  return Boolean(billingWebConfig.billingApiBaseUrl);
}

export function isPublicWebCheckoutEnabled() {
  return billingWebConfig.publicWebCheckoutEnabled === true && isBillingApiConfigured() && isFirebaseConfigured();
}

export const BILLING_PATHS = {
  entitlement: "/v1/billing/entitlement",
  entitlementSync: "/v1/billing/entitlement/sync",
  checkoutSessions: "/v1/billing/stripe/checkout-sessions",
  portalSessions: "/v1/billing/stripe/portal-sessions",
};

export const ACCOUNT_PATHS = {
  lifecycle: "/v1/account/lifecycle",
  register: "/v1/account/register",
  profile: "/v1/account/profile",
  usage: "/v1/account/usage",
  preferences: "/v1/account/preferences",
  export: "/v1/account/export",
  deletion: "/v1/account/deletion",
  deletionReceipt: "/v1/account/deletion/receipt",
};

export const EXPECTED_FIREBASE_PROJECT_ID = "nebula-database-39c64";
export const STAGING_FIREBASE_PROJECT_ID = "stratify-billing-staging";
export const SANDBOX_ORIGIN = "http://localhost:3000";
